import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "earningFilled"
const EarningFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.843 18.375C9.398 19.721 10.315 20.878 11.473 21.727Q11.365 21.75 11.25 21.75H3.75C3.129 21.75 2.625 21.246 2.625 20.625V19.5C2.625 18.879 3.129 18.375 3.75 18.375zM16.695 12.824C17.107 12.887 17.535 13.067 17.887 13.342L17.407 14.088C17.123 13.884 16.74 13.728 16.298 13.728 15.81 13.727 15.526 13.945 15.526 14.227 15.525 14.92 18 14.685 18 16.428 18 17.149 17.482 17.745 16.695 17.918V18.75H15.795V17.934C15.27 17.848 14.677 17.596 14.25 17.157L14.827 16.482C15.187 16.796 15.645 17.022 16.2 17.022 16.71 17.023 16.988 16.757 16.988 16.443 16.988 15.556 14.512 15.932 14.512 14.222 14.512 13.412 15.112 12.972 15.795 12.831V12H16.695z" />
          <path
            fillRule="evenodd"
            d="M16.125 9C19.645 9 22.5 11.854 22.5 15.375S19.646 21.75 16.125 21.75 9.75 18.896 9.75 15.375 12.604 9 16.125 9M16.125 10.5C13.433 10.5 11.25 12.683 11.25 15.375S13.433 20.25 16.125 20.25 21 18.067 21 15.375 18.817 10.5 16.125 10.5"
            clipRule="evenodd"
          />
          <path d="M8.331 14.25Q8.251 14.801 8.25 15.375C8.25 16.157 8.366 16.912 8.578 17.625H3.75C3.129 17.625 2.625 17.121 2.625 16.5V15.375C2.625 14.754 3.129 14.25 3.75 14.25zM10.257 10.125C9.409 11.072 8.787 12.225 8.477 13.5H5.25C4.629 13.5 4.125 12.996 4.125 12.375V11.25C4.125 10.629 4.629 10.125 5.25 10.125zM12 6C12.621 6 13.125 6.504 13.125 7.125V8.093C12.357 8.409 11.651 8.845 11.027 9.375H4.5C3.879 9.375 3.375 8.871 3.375 8.25V7.125C3.375 6.504 3.879 6 4.5 6zM10.875 1.875C11.496 1.875 12 2.379 12 3V4.125C12 4.746 11.496 5.25 10.875 5.25H3.375C2.754 5.25 2.25 4.746 2.25 4.125V3C2.25 2.379 2.754 1.875 3.375 1.875z" />
        </svg>
      }
    </span>
  )
}
export default EarningFilledIcon
